import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Button,
    Typography,
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
    Chip,
    Stack,
    InputAdornment,
    TablePagination,
    Autocomplete,
    Menu,
    MenuItem
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import "../../styles/global.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { getAllAdmins, createDirectorForSchool, GetAllSchoolList, searchDirector, createSuperDirectorForSchool } from "../../api/auth/authService";
import { GetAllAdminsSchool } from "../../api/auth/authService";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "../../components/SnackBar/SnackbarContext";
import * as Yup from 'yup';
import configAPI from "../../api/config";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { encryptPasswordAES } from "../../services/EncriptPasswordAES";
import { DuplicateGroupIdDirectorMessage } from "../../constants/params/constants";
const STATIC_ROLE_ID = "a2967404-24f8-42aa-9ba4-c272631f8048";
const CreateDirector = () => {
    const today = dayjs();
    const [profileImageName, setProfileImageName] = useState("");
    const { showSnackbar } = useSnackbar();
    const user = useSelector((state) => state.auth?.user);
    const BASE_URL = configAPI.REACT_APP_API_BASE_URL;
    const [roleName, setRoleName] = useState("");
    const [totalCount, setTotalCount] = useState(1);
    const [loading, setLoading] = useState(false);
    const validationSchema = Yup.object().shape({
        FirstName: Yup.string().required("First Name is required"),
        LastName: Yup.string().required("Last Name is required"),
        Email: Yup.string()
            .email("Invalid email format")
            .required("Email is required"),
        PhoneNumber: Yup.string()
            .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
            .required("Phone number is required"),
        Password: Yup.string()
            .when('isEditMode', {
                is: false,
                then: (schema) => schema
                    .required("Password is required")
                    .min(8, "Password must be at least 8 characters long")
                    .max(50, "Password cannot exceed 50 characters")
                    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
                    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
                    .matches(/[0-9]/, "Password must contain at least one number")
                    .matches(/[^a-zA-Z0-9]/, "Add Special characters."),
                otherwise: (schema) => schema
                    .optional()
                    .nullable()
            }),
    
        SchoolID: Yup.string()
            .uuid("School ID must be a valid UUID")
            .required("School is required"),
        ProfileImage: Yup.mixed()
            .required("Profile image is required")
            .test(
                "file",
                "Profile image is required",
                (value) => value !== null && value !== undefined
            ),
    });
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [formData, setFormData] = useState({
        FirstName: "",
        LastName: "",
        SchoolID: "",
        Email: "",
        PhoneNumber: "",
        Password: "",
        ProfileImage: null,
        ProfilePreview: null
    });

    const [openModal, setOpenModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [viewAdmin, setViewAdmin] = useState(null);
    const [editingAdminId, setEditingAdminId] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [focused, setFocused] = useState(false);
    const [errors, setErrors] = useState({});
    const [admins, setAdmins] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
    const [selectedAdminForAction, setSelectedAdminForAction] = useState(null);
    const location = useLocation();
    const [loadingSchools, setLoadingSchools] = useState(true);
    const SchoolForAdmin = location.state?.school;

    const [schools, setSchools] = useState([]);
const [existingProfileImage, setExistingProfileImage] = useState("");
const [openSuperDirectorPopup, setOpenSuperDirectorPopup] = useState(false);
const [isSuperDirectorMode, setIsSuperDirectorMode] = useState(false);
    //     const fetchSchoolsByAdminId = async (adminId) => {
//     try {
//         const res = await GetAllAdminsSchool(adminId);

//         if (res?.success && Array.isArray(res.data)) {
//             return res.data
//                 .map(school => school.schoolName)
//                 .filter(Boolean)
//                 .join(", ");
//         }
//         return "N/A";
//     } catch (err) {
//         console.error("School fetch error:", err);
//         return "N/A";
//     }
// };

    const fetchSchools = async () => {
        setLoadingSchools(true);
        try {
            const response = await GetAllSchoolList();

            if (response.success && response.data) {
                const schoolOptions = response.data.map(school => ({
                    id: school.schoolID,
                    label: school.schoolName
                }));
                setSchools(schoolOptions);
            } else {
                setSchools([]);
            }
        } catch (err) {
            setSchools([]);
            showSnackbar("Failed to load schools", "error");
        } finally {
            setLoadingSchools(false);
        }
    };
    useEffect(() => {
        fetchSchools();
    }, []);
    useEffect(() => {
        if (user) {
            setFormData(prev => ({
                ...prev,
                RoleID: STATIC_ROLE_ID || ""
            }));
            setRoleName(user.roleName || "Director");
        }
        if (SchoolForAdmin) {
            setFormData(prev => ({
                ...prev,
                SchoolID: SchoolForAdmin?.id || "",
         
               
            }));
            setOpenModal(true);
            setIsEditMode(false);
        }
    }, []);
    useEffect(() => {
        if (user) {
            setRoleName(user.roleName || "Director");
            setFormData(prev => ({
                ...prev,
                RoleID: STATIC_ROLE_ID|| ""
            }));
        }
    }, [user]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const schoolOptions = SchoolForAdmin ? { id: SchoolForAdmin.id, label: SchoolForAdmin.SchoolName } : null;
   
    useEffect(() => {
    const fetchAdmins = async () => {
        try {
            const response = await getAllAdmins(page + 1, rowsPerPage);

            if (response.success && response.data?.data) {
   const directorAdmins = response.data.data.filter(
          (admin) => admin.roleName === "Director"
        );
              
              const fetchedAdmins = directorAdmins.map((admin) => ({
          id: admin.adminID,
          FirstName: admin.firstName || "",
          LastName: admin.lastName || "",
          Email: admin.email || "",
          PhoneNumber: admin.phoneNumber || "",

          RoleID: admin.roleID || "",
          SchoolID: admin.schools?.[0]?.schoolID || "",

          schoolName: admin.schools?.length
            ? admin.schools.map(s => s.schoolName).join(", ")
            : "N/A",

          ExpiryDate: admin.expiryDate ? new Date(admin.expiryDate) : null,
          RegistrationDate: admin.createdAt
            ? new Date(admin.createdAt).toLocaleDateString()
            : "N/A",

          ProfilePreview: admin.profileImage
            ? `${BASE_URL}${admin.profileImage}`
            : null,

          Status: admin.isActive ? "Active" : "Inactive"
        }));

                 setAdmins(fetchedAdmins);
        setTotalCount(response.data.totalCount || 0);
      } else {
        setAdmins([]);
        setTotalCount(0);
      }
    } catch (error) {
      setAdmins([]);
      setTotalCount(0);
      showSnackbar("Failed to load admins", "error");
    }
  };


    fetchAdmins();
}, [page, rowsPerPage]);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleActionMenuOpen = (event, admin) => {
        setActionMenuAnchor(event.currentTarget);
        setSelectedAdminForAction(admin);
    };

    const handleActionMenuClose = () => {
        setActionMenuAnchor(null);
        setSelectedAdminForAction(null);
    };

    const handleViewFromMenu = () => {
        if (selectedAdminForAction) {
            setViewAdmin(selectedAdminForAction);
            handleActionMenuClose();
        }
    };

    const handleEditFromMenu = () => {
        if (selectedAdminForAction) {
            setFormData({
                FirstName: selectedAdminForAction.FirstName,
                LastName: selectedAdminForAction.LastName,
                SchoolID: selectedAdminForAction.SchoolID,
                Email: selectedAdminForAction.Email,
                PhoneNumber: selectedAdminForAction.PhoneNumber,
                Password: selectedAdminForAction.Password,
                ProfileImage: null,
                ProfilePreview: selectedAdminForAction.ProfilePreview
            });
            setEditingAdminId(selectedAdminForAction.id);
            setIsEditMode(true);
            setOpenModal(true);
            handleActionMenuClose();
        }
    };

    const handleDeleteFromMenu = () => {
        if (selectedAdminForAction) {
            handleActionMenuClose();
            setTimeout(() => {
                if (window.confirm("Are you sure you want to delete this admin?")) {
                    setAdmins(admins.filter(admin => admin.id !== selectedAdminForAction.id));
                }
            }, 100);
        }
    };

const [searchValue, setSearchValue] = useState("");
const [searchResult, setSearchResult] = useState(null);
const [searchLoading, setSearchLoading] = useState(false);
const [showCreateForm, setShowCreateForm] = useState(false);


// const handleSearchDirector = async () => {
//   if (!searchValue) {
//     showSnackbar("Please enter Email / Phone / Director ID", "warning");
//     return;
//   }

//   try {
//     setSearchLoading(true);
//     const response = await searchDirector(searchValue);

//     if (response?.success && response?.data?.length > 0) {
//       const director = response.data[0];

//       setSearchResult(director);
//       setShowCreateForm(false);

//    showSnackbar("This director is already registered.", "info");
//     } else {
//       setSearchResult(null);
//       setShowCreateForm(true);
//       showSnackbar("Director not found. Please create new director.", "info");
//     }
//   } catch (error) {
//     showSnackbar("Search failed", "error");
//   } finally {
//     setSearchLoading(false);
//   }
// };

const handleSearchDirector = async () => {
  if (!searchValue) {
    showSnackbar("Please enter Email / Phone / Director ID", "warning");
    return;
  }

  try {
    setSearchLoading(true);
    const response = await searchDirector(searchValue);

    if (response?.success && response?.data?.length > 0) {
      const director = response.data[0];

      setFormData(prev => ({
        ...prev,
        FirstName: director.FirstName || "",
        LastName: director.LastName || "",
        Email: director.Email || "",
        PhoneNumber: director.PhoneNumber || "",
      Password: director.Password || "", 
        // ProfileImage ko null rakho because ye existing image hai
        ProfileImage: null,
        ProfilePreview: director.ProfileImage
          ? `${BASE_URL}${director.ProfileImage}`
          : null
      }));

      // Profile image name set karo for display
      if (director.ProfileImage) {
        const imageName = director.ProfileImage.split("/").pop();
        setProfileImageName(imageName);
        setExistingProfileImage(imageName);
      } else {
        setProfileImageName("");
        setExistingProfileImage("");
      }

      setSearchResult(director);
      setShowCreateForm(false);

      showSnackbar("This director is already registered.", "info");
    } else {
      setSearchResult(null);
      setShowCreateForm(true);
      resetForm();
      setExistingProfileImage(""); // Reset existing image
      setProfileImageName(""); // Reset profile image name
      showSnackbar("Director not found. Please create new director.", "info");
    }
  } catch (error) {
    showSnackbar("Search failed", "error");
  } finally {
    setSearchLoading(false);
  }
};

const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: undefined }));
        }
    };

    const handleDateChange = (date) => {
        setFormData(prev => ({ ...prev, ExpiryDate: date }));

        if (errors.ExpiryDate) {
            setErrors(prev => ({ ...prev, ExpiryDate: undefined }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                ProfileImage: file,
                ProfilePreview: URL.createObjectURL(file)
            }));
            setProfileImageName(file.name);
        }
    };

    const handleAddAdminClick = () => {
        resetForm();
        if (user) {
            setFormData(prev => ({
                ...prev,
                RoleID: STATIC_ROLE_ID|| ""
            }));
        }
        setIsEditMode(false);
        setEditingAdminId(null);
        setOpenModal(true);
        navigate(location.pathname, { replace: true, state: {} });
    };

    const handleEditAdmin = (admin) => {
        setFormData({
            FirstName: admin.FirstName,
            LastName: admin.LastName,
            SchoolID: admin.SchoolID,
            Email: admin.Email,
            PhoneNumber: admin.PhoneNumber,
            Password: admin.Password,
            ProfileImage: null,
            ProfilePreview: admin.ProfilePreview
        });
        setEditingAdminId(admin.id);
        setIsEditMode(true);
        setOpenModal(true);
    };

    const handleViewAdmin = (admin) => {
        setViewAdmin(admin);
    };

    const handleCloseView = () => {
        setViewAdmin(null);
    };

//     const handleSubmit = async () => {
//         debugger; // eslint-disable-line no-debugger
//         try {
//              const encryptedPassword = encryptPasswordAES(formData.Password);
//             await validationSchema.validate(
//                 { ...formData, isEditMode },
//                 { abortEarly: false }
//             );

//             setErrors({});

//             const submitData = new FormData();
//             submitData.append("FirstName", formData.FirstName);
//             submitData.append("LastName", formData.LastName);
//             submitData.append("Email", formData.Email);
//             submitData.append("PhoneNumber", formData.PhoneNumber);
//             if (!isEditMode) {
//                 submitData.append("Password", encryptedPassword);
//             }
//             submitData.append("SchoolID", formData.SchoolID);
//             if (formData.ProfileImage) {
//                 submitData.append("ProfileImage", formData.ProfileImage);
//             }

//             const response = await createDirectorForSchool(submitData);
      
// debugger; // eslint-disable-line no-debugger

//             if (response.success || response.data?.success) {
//                 showSnackbar('Director registered successfully!', 'success');
//                 const fetchResponse = await getAllAdmins(1, rowsPerPage);
//                 if (fetchResponse.success && fetchResponse.data?.data) {
//                     const updatedAdmins = fetchResponse.data?.data.map(admin => ({
//                         id: admin.adminID,
//                         FirstName: admin.firstName || "",
//                         LastName: admin.lastName || "",
//                         Email: admin.email || "",
//                         PhoneNumber: admin.phoneNumber || "",
//                         SchoolID: admin.schoolID || "",
//                         schoolName: admin.schoolName || "N/A",
//                         RoleID: admin.roleID || "",
//                         ExpiryDate: admin.expiryDate ? new Date(admin.expiryDate) : null,
//                         RegistrationDate: admin.createdAt ? new Date(admin.createdAt).toLocaleDateString() : "N/A",
//                         ProfilePreview: admin.profileImage
//                             ? `${BASE_URL}${admin.profileImage}`
//                             : null,
//                         Status: admin.isActive ? "Active" : "Inactive"
//                     }));
//                     setAdmins(updatedAdmins);
//                 }

//                 resetForm();
//                 handleCloseModal();
//             } else {
//                 const errorMessage = response.message || "Failed to register admin";
//                 showSnackbar(errorMessage, 'error');
//             }
//         } catch (err) {
//             if (err.name === "ValidationError") {
//                 const newErrors = {};
//                 err.inner.forEach(error => {
//                     newErrors[error.path] = error.message;
//                 });
//                 setErrors(newErrors);
//             } else {
//                 console.error(err);
//                 showSnackbar('Failed to register admin', 'error');
//             }
//         }
//     };
const handleSubmit = async () => {
    try {
       let finalPassword = formData.Password;

    if (!searchResult) {
      finalPassword = encryptPasswordAES(formData.Password);
    }

        // await validationSchema.validate(
        //     { ...formData, isEditMode },
        //     { abortEarly: false }
        // );

        setErrors({});

        const submitData = new FormData();
        submitData.append("FirstName", formData.FirstName);
        submitData.append("LastName", formData.LastName);
        submitData.append("Email", formData.Email);
        submitData.append("PhoneNumber", formData.PhoneNumber);
        submitData.append("SchoolID", SchoolForAdmin?.id);
        submitData.append("Password", finalPassword);
        if (formData.ProfileImage) {
            submitData.append("ProfileImage", formData.ProfileImage);
        }
 submitData.append("IsSuperDirector", isSuperDirectorMode);


      let response;

if (isSuperDirectorMode) {
    response = await createSuperDirectorForSchool(submitData);
} else {
    response = await createDirectorForSchool(submitData);
}

        if (response?.success) {
        showSnackbar(
        isSuperDirectorMode 
            ? "Super Director registered successfully" 
            : "Director Register successful",
        "success"
    );
                setIsSuperDirectorMode(false);

            const fetchResponse = await getAllAdmins(page + 1, rowsPerPage);

            if (fetchResponse.success && fetchResponse.data?.data) {
                const updatedAdmins = fetchResponse.data.data.map((admin) => ({
                    id: admin.adminID,
                    FirstName: admin.firstName || "",
                    LastName: admin.lastName || "",
                    Email: admin.email || "",
                    PhoneNumber: admin.phoneNumber || "",
                    RoleID: admin.roleID || "",
                    SchoolID: admin.schools?.[0]?.schoolID || "",
                    schoolName: admin.schools?.length
                        ? admin.schools.map(s => s.schoolName).join(", ")
                        : "N/A",
                    ExpiryDate: admin.expiryDate
                        ? new Date(admin.expiryDate)
                        : null,
                    RegistrationDate: admin.createdAt
                        ? new Date(admin.createdAt).toLocaleDateString()
                        : "N/A",
                    ProfilePreview: admin.profileImage
                        ? `${BASE_URL}${admin.profileImage}`
                        : null,
                    Status: admin.isActive ? "Active" : "Inactive"
                }));

                setAdmins(updatedAdmins);
                setTotalCount(fetchResponse.data.totalCount || 0);
            }

            resetForm();
            handleCloseModal();
        } else {
            if(response?.message === DuplicateGroupIdDirectorMessage)
{
    setOpenSuperDirectorPopup(true);

}   else{
  showSnackbar(response?.message || "Director registration failed", "error");
}  
        }

    } catch (err) {
        if (err.name === "ValidationError") {
            const newErrors = {};
            err.inner.forEach(error => {
                newErrors[error.path] = error.message;
            });
            setErrors(newErrors);
        } else {
            showSnackbar("Failed to register Director", "error");
        }
    }
};

const handleCreateSuperDirector = async () => {
    try {
        let finalPassword = formData.Password;

        if (!searchResult) {
            finalPassword = encryptPasswordAES(formData.Password);
        }

        const submitData = new FormData();
        submitData.append("FirstName", formData.FirstName);
        submitData.append("LastName", formData.LastName);
        submitData.append("Email", formData.Email);
        submitData.append("PhoneNumber", formData.PhoneNumber);
        submitData.append("SchoolID", formData.SchoolID);
        submitData.append("Password", finalPassword);

        if (formData.ProfileImage) {
            submitData.append("ProfileImage", formData.ProfileImage);
        }

        submitData.append("IsSuperDirector", true);

        const response = await createSuperDirectorForSchool(submitData);

        if (response?.success) {
            showSnackbar("Super Director registered successfully", "success");
            setOpenSuperDirectorPopup(false);
            handleCloseModal();
        } else {
            showSnackbar(response?.message || "Failed to create Super Director", "error");
        }

    } catch (error) {
        showSnackbar("Something went wrong", "error");
    }
};

    const handleDeleteAdmin = (id) => {
        setAdmins(admins.filter(admin => admin.id !== id));
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        resetForm();
        setIsEditMode(false);
        setEditingAdminId(null);
        navigate(location.pathname, { replace: true, state: {} });
    };

    // const resetForm = () => {
const resetForm = () => {
    setFormData({
        FirstName: "",
        LastName: "",
        Email: "",
        PhoneNumber: "",
        Password: "",
        ProfileImage: null,
        ProfilePreview: null,
        SchoolID: SchoolForAdmin?.id || ""
    });

    setSearchResult(null);
    setExistingProfileImage("");
    setProfileImageName("");
};
    
const filteredAdmins = admins.filter((admin) => {
  const search = searchTerm.toLowerCase();

  return (
    admin.FirstName?.toLowerCase().includes(search) ||
    admin.LastName?.toLowerCase().includes(search) ||
    admin.Email?.toLowerCase().includes(search) ||       
    admin.schoolName?.toLowerCase().includes(search)      
  );
});

    return (
        <Box p={0}>
            <Box sx={{
                background: "#fff",
                borderRadius: 2,
                pt: 3,
                px: 3,
                pb: 1,
            }}>
              
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "stretch", sm: "center" },
                        gap: 2,
                        p: 2,
                        mb: 2,
                        borderRadius: "8px",
                        background: "linear-gradient(135deg, #f5f9ff, #eef3ff)",
                        border: "1px solid #e0e7ff",
                    }}
                >
                    <Box >
                        <Typography
                            variant="h6"
                            fontWeight={700}
                            sx={{ color: "#1e3a8a", lineHeight: 1.2 }}
                        >
                            Registered Director
                        </Typography>

                        <Typography variant="caption" sx={{ color: "#64748b" }}>
                            Manage all system administrators
                        </Typography>

                        <Box sx={{ mt: 1 }}>
                            <TextField
                                fullWidth
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                size="small"
                            />
                        </Box>
                    </Box>

                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleAddAdminClick}
                        sx={{
                            alignSelf: { xs: "stretch", sm: "center", },
                            "&:hover": { boxShadow: "none" },
                        }}
                    >
                        Add New Director
                    </Button>
                </Box>
                {totalCount === 0 ? (
                    <Box
                        sx={{
                            textAlign: 'center',
                            py: 8,
                            border: '2px dashed #e0e0e0',
                            borderRadius: 2
                        }}
                    >
                        <Typography color="textSecondary" variant="h6" gutterBottom>
                            No Admins Found
                        </Typography>
                        <Typography color="textSecondary" variant="body1" paragraph>
                            Click on "Add New Director" button to register your first admin
                        </Typography>
                    </Box>
                ) : (
                    <TableContainer sx={{ boxShadow: 'none', border: '1px solid #d7d0d0ff',maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>S.No.</strong></TableCell>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>Profile</strong></TableCell>
                                    <TableCell sx={{minWidth:120,padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>First Name</strong></TableCell>
                                    <TableCell sx={{minWidth:100,padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>Last Name</strong></TableCell>
                                    <TableCell sx={{minWidth:170,padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>UserName</strong></TableCell>
                                        <TableCell sx={{ minWidth: 180, padding: '8px', backgroundColor: '#f5f5f5', fontSize: '13px' }}>
                                            <strong>School Name</strong>
                                        </TableCell>

                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>Phone</strong></TableCell>
                                    {/* <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>School ID</strong></TableCell> */}
                                    {/* <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>Role ID</strong></TableCell> */}
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>Reg. Date</strong></TableCell>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>Actions</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredAdmins
                                    .map((admin, index) => (
                                        <TableRow key={admin.id} hover>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
                                                {page * rowsPerPage + index + 1}
                                            </TableCell>
                                            <TableCell sx={{ padding: '8px' }}>
                                                {admin.ProfilePreview ? (
                                                    <Avatar
                                                        src={admin.ProfilePreview}
                                                        sx={{ width: 40, height: 40 }}
                                                    />
                                                ) : (
                                                    <Avatar sx={{ width: 40, height: 40, bgcolor: '#1976d2' }}>
                                                        {admin.FirstName?.charAt(0) || 'A'}
                                                    </Avatar>
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>{admin.FirstName}</TableCell>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>{admin.LastName}</TableCell>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>{admin.Email}</TableCell>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
                                                {admin.schoolName || 'N/A'}
                                            </TableCell>

                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>{admin.PhoneNumber}</TableCell>
                                          
                                          
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>{admin.RegistrationDate}</TableCell>
                                            <TableCell sx={{ padding: '8px'}}>
                                                <Stack direction="row" spacing={1}>
                                                    <Tooltip title="More Actions">
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) => handleActionMenuOpen(e, admin)}
                                                        >
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                />
            </Box>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'primary.main',
                    color: 'white'
                }}>
                    <Typography variant="h6">
                        {/* {isEditMode ? 'Edit Director' : 'Register New Director'} */}
                        {isSuperDirectorMode 
    ? "Register Super Director"
    : isEditMode 
        ? "Edit Director" 
        : "Register New Director"}
                    </Typography>
                    <IconButton onClick={handleCloseModal} sx={{ color: 'white' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers sx={{ pt: 3 }}>
                    <Grid container spacing={2} mb={2}>
  <Grid item xs={12} sm={9}>
    <TextField
      fullWidth
      size="small"
      label="Search Director (Email / Phone / ID)"
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
    />
  </Grid>

  <Grid item xs={12} sm={3}>
    <Button
      fullWidth
      variant="contained"
      onClick={handleSearchDirector}
      disabled={searchLoading}
    >
      {searchLoading ? "Searching..." : "Search"}
    </Button>
  </Grid>
</Grid>


 
                    <Box component="form" noValidate>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="First Name"
                                    name="FirstName"
                                    value={formData.FirstName}
                                    onChange={handleChange}
                                    variant="filled"
                                    className={`cp-form-control input-focus ${errors.FirstName ? "error" : ""}`}
                                    required
                                    // error={!!errors.FirstName}
                                    // helperText={errors.FirstName}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                    }}
                                  InputProps={{
    readOnly: !!searchResult
  }}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="Last Name"
                                    name="LastName"
                                    value={formData.LastName}
                                    onChange={handleChange}
                                    variant="filled"
                                    className={`cp-form-control input-focus ${errors.LastName ? "error" : ""}`}
                                    required
                                    // error={!!errors.LastName}
                                    // helperText={errors.LastName}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                    }}
                                   InputProps={{
    readOnly: !!searchResult
  }}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Autocomplete
                                    className={`cp-autocomplete-clean ${errors.SchoolID ? "error" : ""}`}
                                    size="small"
                                    options={SchoolForAdmin ? [] : schools}
                                    getOptionLabel={(option) => option.label || ""}
                                    value={
                                        SchoolForAdmin
                                            ? { id: SchoolForAdmin.id, label: SchoolForAdmin.SchoolName || "Unknown School" }
                                            : schools.find(item => item.id === formData.SchoolID) || null
                                    }
                                    onChange={(event, newValue) => {
                                        if (!SchoolForAdmin) {
                                            setFormData(prev => ({
                                                ...prev,
                                                SchoolID: newValue ? newValue.id : ""
                                            }));
                                        }
                                    }}
                                    disabled={!!SchoolForAdmin}
                                    loading={loadingSchools}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="School Name"
                                            variant="filled"
                                            size="small"
                                            fullWidth
                                            required
                                            InputProps={{
                                                ...params.InputProps,
                                                readOnly: !!SchoolForAdmin,
                                            }}
                                        />
                                    )}
                                />
                                <input
                                    type="hidden"
                                    name="SchoolID"
                                    value={SchoolForAdmin ? SchoolForAdmin.id : formData.SchoolID}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="Email"
                                    name="Email"
                                    value={formData.Email}
                                    onChange={handleChange}
                                    variant="filled"
                                    className={`cp-form-control input-focus ${errors.Email ? "error" : ""}`}
                                    required
                                      InputProps={{
    readOnly: !!searchResult
  }}
                                // error={!!errors.Email}
                                // helperText={errors.Email}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="Phone Number"
                                    name="PhoneNumber"
                                    value={formData.PhoneNumber}
                                    variant="filled"
                                    className={`cp-form-control input-focus ${errors.PhoneNumber ? "error" : ""}`}
                                    // className={`cp-form-control input-focus ${errors.PhoneNumber ? "error" : ""}`}
                                    required
                                    // error={!!errors.PhoneNumber}
                                    // helperText={errors.PhoneNumber}
                                 InputProps={{
    readOnly: !!searchResult
  }}
                                    onChange={(e) => {
                                        const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                                        handleChange({
                                            target: {
                                                name: "PhoneNumber",
                                                value: onlyNumbers
                                            }
                                        });
                                    }}
                                />
                            </Grid>
{!searchResult && (

                            <Grid size={{ xs: 12, sm: 4 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    type={showPassword ? "text" : "password"}
                                    label="Password"
                                    name="Password"
                                    value={formData.Password}
                                    onChange={handleChange}
                                    variant="filled"
                                    // error={!!errors.Password}
                                    // helperText={errors.Password}
                                    className={`cp-form-control input-focus ${errors.Password ? "error" : ""}`}
                                    required={!isEditMode}
                                    InputProps={{
                                           readOnly: !!searchResult,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    edge="end"
                                                    tabIndex={-1}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    
                                />
                            </Grid>
)}
                       
                       
{/* 
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Button variant="outline" sx={{ py: '10px' }} className={`cp-form-control input-focus fs-8 ${errors.ProfileImage ? "error" : ""}`} component="label" fullWidth>
                                    <i class="fa-sharp fa-light fa-file-user"></i> Upload Profile Image
                                    <input
                                        type="file"
                                        hidden
                                        name="ProfileImage"
                                        onChange={handleFileChange}
                                    />
                                </Button>
                                {formData.ProfilePreview && (
                                    <Typography mt={1} fontSize="small" color="text.secondary">
                                        {profileImageName}
                                    </Typography>
                                )}
                            </Grid> */}
                            {!searchResult && (
<Grid size={{ xs: 12, sm: 4 }}>
  
  {/* 🔹 Agar existing image hai → Upload button hide */}
  {!existingProfileImage && (
    <Button
      variant="outlined"
      sx={{
        py: "14px",
        borderRadius: "8px",
        textTransform: "uppercase",
        fontWeight: 500
      }}
      component="label"
      fullWidth
    >
      Upload Profile Image
      <input
        type="file"
        hidden
        name="ProfileImage"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            setFormData(prev => ({
              ...prev,
              ProfileImage: file
            }));
            setProfileImageName(file.name);
          }
        }}
      />
    </Button>
  )}

  {existingProfileImage && (
    <Typography mt={1.5} fontSize="14px" color="#6b6b6b">
      {existingProfileImage}
    </Typography>
  )}

  {!existingProfileImage && profileImageName && (
    <Typography mt={1.5} fontSize="14px" color="#6b6b6b">
      {profileImageName}
    </Typography>
  )}

</Grid>
)}
                        </Grid>
                    </Box>


                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        sx={{
                            boxShadow: "none",
                            '&:hover': {
                                boxShadow: "none"
                            }
                        }}
                    >
                        {isEditMode ? 'Update Director' : 'Register Director'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={!!viewAdmin}
                onClose={handleCloseView}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Typography variant="h6">Director Details</Typography>
                    <IconButton onClick={handleCloseView}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    {viewAdmin && (
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                {viewAdmin.ProfilePreview ? (
                                    <Avatar
                                        src={viewAdmin.ProfilePreview}
                                        sx={{ width: 80, height: 80, mr: 3 }}
                                    />
                                ) : (
                                    <Avatar sx={{
                                        width: 80,
                                        height: 80,
                                        mr: 3,
                                        bgcolor: '#1976d2',
                                        fontSize: '1.5rem'
                                    }}>
                                        {viewAdmin.FirstName?.charAt(0) || 'A'}
                                    </Avatar>
                                )}
                                <Box>
                                    <Typography variant="h5" gutterBottom>
                                        {viewAdmin.FirstName} {viewAdmin.LastName}
                                    </Typography>
                                    <Chip
                                        label={viewAdmin.Status || "Active"}
                                        color="success"
                                        size="small"
                                    />
                                </Box>
                            </Box>

                            <Grid container spacing={2}>
                                <Grid size={{ xs: 6 }}>
                                    <Typography variant="caption" color="textSecondary">
                                        Email
                                    </Typography>
                                    <Typography variant="body1">{viewAdmin.Email}</Typography>
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <Typography variant="caption" color="textSecondary">
                                        Phone
                                    </Typography>
                                    <Typography variant="body1">{viewAdmin.PhoneNumber}</Typography>
                                </Grid>
                            
                                <Grid size={{ xs: 6 }}>
                                    <Typography variant="caption" color="textSecondary">
                                        Registration Date
                                    </Typography>
                                    <Typography variant="body1">{viewAdmin.RegistrationDate}</Typography>
                                </Grid>
                               
                            </Grid>
                        </Box>
                    )}
                </DialogContent>

                
            </Dialog>
<Dialog
    open={openSuperDirectorPopup}
    onClose={() => setOpenSuperDirectorPopup(false)}
    maxWidth="xs"
    fullWidth
>
    <DialogTitle>
        Super Director Required
    </DialogTitle>

    <DialogContent dividers>
        <Typography>
            This group already has a director assigned.
            <br /><br />
            Do you want to create a Super Director instead?
        </Typography>
    </DialogContent>

    <DialogActions>
        <Button
            onClick={() => {
                setOpenSuperDirectorPopup(false);
                handleCloseModal(); 
            }}
            color="error"
            variant="outlined"
        >
            No
        </Button>

        <Button
      onClick={() => {
    setOpenSuperDirectorPopup(false);
    setIsSuperDirectorMode(true);
resetForm();
}}
            color="primary"
            variant="contained"
        >
            Yes
        </Button>
    </DialogActions>
</Dialog>
            <Menu
                anchorEl={actionMenuAnchor}
                open={Boolean(actionMenuAnchor)}
                onClose={handleActionMenuClose}
                PaperProps={{
                    sx: {
                        minWidth: 180
                    }
                }}
            >
                {selectedAdminForAction && (
                    <>
                        <MenuItem
                            onClick={handleViewFromMenu}
                        >
                            <VisibilityIcon fontSize="small" sx={{ mr: 1, color: 'info.main' }} />
                            View Details
                        </MenuItem>
               
                    </>
                )}
            </Menu>
        </Box>
    );
};

export default CreateDirector;